export const BRAND = 'One Kings Lane'
